export function flipHorizontal(path, gridSize = 4) {
  return path.map((index) => {
    const row = Math.floor(index / gridSize);
    const col = index % gridSize;
    return row * gridSize + (gridSize - 1 - col);
  });
}

export function flipVertical(path, gridSize = 4) {
  return path.map((index) => {
    const row = Math.floor(index / gridSize);
    const col = index % gridSize;
    return (gridSize - 1 - row) * gridSize + col;
  });
}

function isValidPath(path) {
  return Array.isArray(path) && path.length > 0 && path.every((n) => Number.isInteger(n));
}

export function isValidPattern(pattern) {
  if (pattern == null || typeof pattern !== 'object' || Array.isArray(pattern)) {
    return false;
  }
  if (!isValidPath(pattern.path)) {
    return false;
  }
  const pos = pattern['one-point-answer-pos'];
  return Number.isInteger(pos) && pos >= 0 && pos <= pattern.path.length;
}

export function savePatternPath(pattern) {
  localStorage.setItem('patternPath', JSON.stringify(pattern));
}

export function getStoredPattern() {
  const raw = localStorage.getItem('patternPath');
  if (raw === null || raw === '') {
    throw new Error('patternPath missing in localStorage');
  }
  let pattern;
  try {
    pattern = JSON.parse(raw);
  } catch {
    throw new Error(`Invalid patternPath JSON in localStorage: "${raw}"`);
  }
  if (!isValidPattern(pattern)) {
    throw new Error(`Invalid patternPath in localStorage: "${raw}"`);
  }
  return pattern;
}

export function pickRandomPattern(patterns) {
  if (!Array.isArray(patterns) || patterns.length === 0) {
    throw new Error('patterns catalog is empty.');
  }
  return patterns[Math.floor(Math.random() * patterns.length)];
}

/**
 * Formal entry from GET:
 * - omitted / null patternPath → pick a random catalog pattern (new test)
 * - valid patternPath object → resume
 * - present but invalid → throw
 */
export function resolvePatternFromGetResponse(response, patterns) {
  if (response == null || !('patternPath' in response) || response.patternPath == null) {
    return pickRandomPattern(patterns);
  }
  if (!isValidPattern(response.patternPath)) {
    throw new Error(`Invalid patternPath from GET: ${JSON.stringify(response.patternPath)}`);
  }
  return response.patternPath;
}

function demoRightForTransform(demoLeft, transform, gridSize) {
  if (transform === 'horizontal') {
    return flipHorizontal(demoLeft, gridSize);
  }
  if (transform === 'vertical') {
    return flipVertical(demoLeft, gridSize);
  }
  return demoLeft;
}

function answerForTransform(path, transform, gridSize) {
  if (transform === 'horizontal') {
    return flipHorizontal(path, gridSize);
  }
  if (transform === 'vertical') {
    return flipVertical(path, gridSize);
  }
  return path;
}

export function resolveLevel(levelDef, pattern, testData, { showVideo }) {
  const gridSize = testData['grid-size'];
  const demoLeft = testData['demo-grid-left'];

  if (levelDef.mode === 'practice') {
    const practicePath = levelDef.path;
    return {
      leftGrid: practicePath,
      answer: practicePath,
      onePointAnswerPos: levelDef['one-point-answer-pos'] ?? 0,
      demoLeft: practicePath,
      demoRight: practicePath,
    };
  }

  if (showVideo) {
    return {
      leftGrid: demoLeft,
      answer: demoLeft,
      onePointAnswerPos: 0,
      demoLeft,
      demoRight: demoRightForTransform(demoLeft, levelDef.transform, gridSize),
    };
  }

  const leftGrid = pattern.path;
  const answer = answerForTransform(pattern.path, levelDef.transform, gridSize);

  return {
    leftGrid,
    answer,
    onePointAnswerPos: pattern['one-point-answer-pos'],
    demoLeft,
    demoRight: demoRightForTransform(demoLeft, levelDef.transform, gridSize),
  };
}
